import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { ClientDDL } from "@/views/base/base.types";
import { 
  CommercialParticipantModel
} from "@/views/sidebar/commercial-participant/participant.types";
import { ErrorBag, Field } from "vee-validate";

@Component({
  computed: {
    ...mapState("CommercialParticipant", [
      "commercialParticipant"
    ]),
    ...mapState("Base", [
      "selectedClientDDL"
    ])
  }
})
export default class ParticipantMixin extends Vue {
  selectedClientDDL!: ClientDDL;
  commercialParticipant!: CommercialParticipantModel;

  formSubmitted = false;

  veeFields!: Field;
  veeErrors!: ErrorBag;

  dateConfig = {
    format: 'MM/DD/YYYY',
    showClear: true,
    showClose: true,
    showTodayButton: true,
    toolbarPlacement: 'bottom',
    icons: {
      date: 'fa fa-calendar',
      up: 'fa fa-arrow-up',
      down: 'fa fa-arrow-down',
      previous: 'fa fa-chevron-left',
      next: 'fa fa-chevron-right',
      today: 'fa fa-calendar-check',
      clear: 'fa fa-trash',
      close: 'fa fa-times'
    }
  };

  getValidationClass(fieldName: keyof Field) {
    const hasError = this.veeErrors.has(fieldName);
    const isValidated = this.validateState(fieldName);
  
    return {
      'is-invalid': hasError,
      'is-valid': this.formSubmitted && !hasError && isValidated
    };
  }

  validateState(ref: keyof Field) {
    if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || 
        this.veeFields[ref].validated)
    ) {
        return !this.veeErrors.has(ref);
    }
    return null;
  }
}